import React, { Component } from 'react';
import fetch from 'isomorphic-fetch';
import Filter from '../partials/Filter';
import List from '../partials/List';
import Button from '../partials/Button';
import '../../styles/Availability.css';
import ScrollArrow from '../partials/ScrollArrow';
import Floorplan from '../partials/Floorplan';
import { VelocityComponent } from 'velocity-react';

// Temporary residence data and flag for child component
var tempRes = [];
var fromChild = false;

export default class Availability extends Component {
  constructor(props) {
    super(props);
    // Initializing state variables
    this.state = {
      residences: tempRes > 0 ? tempRes : [], // List of residences
      allResidences: [], // Complete list of residences
      filterOverlay: false, // State for filter overlay visibility
      filtersArray: [], // Active filters
      activeResidence: '', // Currently active residence
      floorplanState: '', // State for floorplan visibility
      checkboxArray: [], // Selected checkboxes
      disabledShare: true, // Share button state
      floorplanResidenceArray: [], // Data for the floorplan
      planExists: true // Whether the floorplan exists
    };
    // Binding methods to the component
    this.onFilterClick = this.onFilterClick.bind(this);
    this.onShareClick = this.onShareClick.bind(this);
  }

  componentWillMount() {
    // Set up Google Analytics tracking if on production
    /* if (window.location.origin === 'https://108leonard.com') {
      window.gtag('config', 'UA-113369414-1', {
        page_title:
          '108 Leonard | Available apartments for sale in Tribeca NYC.',
        page_location: window.location.href,
        page_path: window.location.pathname
      });
    } */
  }

  componentDidMount() {
    // Load residences data
    this.loadResidences();

    // Scroll to top of the page after a short delay
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);

    // Set meta tags for the page
    document.title =
      '108 Leonard | Available apartments for sale in Tribeca NYC.';
    if (document.getElementsByTagName('meta').description) {
      document.getElementsByTagName('meta').description.content =
        'Please contact the sales gallery for current availability.';
      document.querySelector("meta[property='og:description']").content =
        'Please contact the sales gallery for current availability.';
      document.querySelector("meta[property='og:title']").content =
        '108 Leonard | Available apartments for sale in Tribeca NYC.';
    }
    if (document.querySelector("link[rel='canonical']")) {
      document.querySelector("link[rel='canonical']").href =
        window.location.href;
      document.querySelector("meta[property='og:url']").content =
        window.location.href;
    }
    var viewport = document.querySelector('meta[name=viewport]');
    if (viewport) {
      viewport.setAttribute(
        'content',
        'width=device-width, initial-scale=1, user-scalable=1'
      );
    }

    // Handle child residence slugs if present in the URL
    if (this.props.match && this.props.match.params.residence) {
      this.showCertainResidences(this.props.match.params.residence);
    }
  }

  loadResidences() {
    // Fetch available residences from the API
    fetch(
      'https://residences.api.dbox.com/getunits/available?projectname=108leonard'
    )
      .then(response => response.json())
      .then(json => {
        // Parse and process the API response
        var parsed = [];
        for (var i in json) {
          if (json[i]) {
            // Get the specific floorplan file for PDF or SVG based on both letter AND number
            let number = parseInt(
              json[i]['unit_num'].split(' (')[0].match(/(\d+|[^\d]+)/g)[0],
              10
            );
            let letter =
              json[i]['unit_num'].indexOf('PH') > -1
                ? json[i]['unit_num'].split(' (')[0]
                : json[i]['unit_num'].split(' (')[0].match(/(\d+|[^\d]+)/g)[1];
            let residencePDFFileName = letter;
            let residenceSVGFileName = letter;
            let keySVGFileName = letter;

            // File name convention:
            // - The file name is determined by the unit's letter and number.
            // - For example, units with the same letter but within a specific range of floors
            //   (e.g., 4-12) will have a shared file name like 'A_4-12'.
            // - Penthouse units (e.g., 'PHNORTH') have unique file names.
            // - The file name is adjusted based on specific conditions for each letter and floor range.

            // Updates Floorplan File Name
            switch (letter) {
              case 'A':
                if (number >= 4 && number <= 12) {
                  residenceSVGFileName = 'A_4-12';
                  residencePDFFileName = 'A_4-12';
                } else if (number === 15) {
                  residenceSVGFileName = 'A_15-1stFl';
                  residencePDFFileName = 'A_15-1stFl';
                } else {
                  residenceSVGFileName = 'A';
                  residencePDFFileName = 'A';
                }
                break;
              case 'B':
                if (number >= 3 && number <= 6) {
                  residenceSVGFileName = 'B_3-6';
                  residencePDFFileName = 'B_3-6';
                } else if (number >= 7 && number <= 12) {
                  residenceSVGFileName = 'B_7-12';
                  residencePDFFileName = 'B_7-12';
                } else if (number === 11) {
                  residenceSVGFileName = 'B_11';
                  residencePDFFileName = 'B_11';
                } else if (number === 14) {
                  residenceSVGFileName = 'B_14';
                  residencePDFFileName = 'B_14';
                } else if (number === 15) {
                  residenceSVGFileName = 'B_15';
                  residencePDFFileName = 'B_15';
                } else {
                  residenceSVGFileName = 'B';
                  residencePDFFileName = 'B';
                }
                break;
              case 'C':
                if (number >= 3 && number <= 6) {
                  residenceSVGFileName = 'C_3-6';
                  residencePDFFileName = 'C_3-6';
                } else if (number >= 7 && number <= 12) {
                  residenceSVGFileName = 'C_7-12';
                  residencePDFFileName = 'C_7-12';
                } else if (number === 14) {
                  residenceSVGFileName = 'C_14';
                  residencePDFFileName = 'C_14';
                } else if (number === 15) {
                  residenceSVGFileName = 'C_15';
                  residencePDFFileName = 'C_15';
                } else {
                  residenceSVGFileName = 'C';
                  residencePDFFileName = 'C';
                }
                break;
              case 'D':
                if (number >= 3 && number <= 5) {
                  residenceSVGFileName = 'D_3-5';
                  residencePDFFileName = 'D_3-5';
                } else if (number >= 7 && number <= 8) {
                  residenceSVGFileName = 'D_7-8';
                  residencePDFFileName = 'D_7-8';
                } else if (number >= 9 && number <= 11) {
                  residenceSVGFileName = 'D_9-11';
                  residencePDFFileName = 'D_9-11';
                } else if (number === 6) {
                  residenceSVGFileName = 'D_6';
                  residencePDFFileName = 'D_6';
                } else if (number === 14) {
                  residenceSVGFileName = 'D_14';
                  residencePDFFileName = 'D_14';
                } else {
                  residenceSVGFileName = 'D';
                  residencePDFFileName = 'D';
                }
                break;
              case 'E':
                if (number === 14) {
                  residenceSVGFileName = 'E_14';
                  residencePDFFileName = 'E_14';
                } else if (number >= 4 && number <= 12) {
                  residenceSVGFileName = 'E_4-12';
                  residencePDFFileName = 'E_4-12';
                } else {
                  residenceSVGFileName = 'E';
                  residencePDFFileName = 'E';
                }
                break;
              case 'F':
                if (number >= 3 && number <= 12) {
                  residenceSVGFileName = 'F_3-12';
                  residencePDFFileName = 'F_3-12';
                } else {
                  residenceSVGFileName = 'F';
                  residencePDFFileName = 'F';
                }
                break;
              case 'G':
                if (number === 3) {
                  residenceSVGFileName = 'G_3';
                  residencePDFFileName = 'G_3';
                } else if (number >= 4 && number <= 6) {
                  residenceSVGFileName = 'G_4-6';
                  residencePDFFileName = 'G_4-6';
                } else if (number >= 7 && number <= 12) {
                  residenceSVGFileName = 'G_7-12';
                  residencePDFFileName = 'G_7-12';
                } else {
                  residenceSVGFileName = 'G';
                  residencePDFFileName = 'G';
                }
                break;
              case 'H':
                if (number >= 4 && number <= 6) {
                  residenceSVGFileName = 'H_4-6';
                  residencePDFFileName = 'H_4-6';
                } else if (number >= 7 && number <= 12) {
                  residenceSVGFileName = 'H_7-12';
                  residencePDFFileName = 'H_7-12';
                } else {
                  residenceSVGFileName = 'H';
                  residencePDFFileName = 'H';
                }
                break;
              case 'I':
                if (number >= 4 && number <= 11) {
                  residenceSVGFileName = 'I_4-11';
                  residencePDFFileName = 'I_4-11';
                }
                break;
              case 'J':
                if (number >= 4 && number <= 11) {
                  residenceSVGFileName = 'J_4-11';
                  residencePDFFileName = 'J_4-11';
                } else if (number === 3) {
                  residenceSVGFileName = 'J_3';
                  residencePDFFileName = 'J_3';
                }
                break;
              case 'K':
                if (number === 12) {
                  residenceSVGFileName = 'K_12';
                  residencePDFFileName = 'K_12';
                } else if (number >= 3 && number <= 11) {
                  residenceSVGFileName = 'K_3-11';
                  residencePDFFileName = 'K_3-11';
                }
                break;
              case 'L':
                if (number === 3) {
                  residenceSVGFileName = 'L_3';
                  residencePDFFileName = 'L_3';
                } else if (number >= 4 && number <= 6) {
                  residenceSVGFileName = 'L_4-6';
                  residencePDFFileName = 'L_4-6';
                } else if (number > 7 && number <= 12) {
                  residenceSVGFileName = 'L_7-12';
                  residencePDFFileName = 'L_7-12';
                } else {
                  residenceSVGFileName = 'L';
                  residencePDFFileName = 'L';
                }
                break;
              case 'M':
                if (number >= 5 && number <= 12) {
                  residenceSVGFileName = 'M_5-12';
                  residencePDFFileName = 'M_5-12';
                } else if (number === 4) {
                  residenceSVGFileName = 'M_4';
                  residencePDFFileName = 'M_4';
                } else {
                  residenceSVGFileName = 'M';
                  residencePDFFileName = 'M';
                }
                break;
              case 'N':
                if (number === 6) {
                  residenceSVGFileName = 'N_6';
                  residencePDFFileName = 'N_6';
                } else if (number === 4) {
                  residenceSVGFileName = 'N_4';
                  residencePDFFileName = 'N_4';
                } else if (number >= 7 && number <= 12) {
                  residenceSVGFileName = 'N_7-12';
                  residencePDFFileName = 'N_7-12';
                } else {
                  residenceSVGFileName = 'N';
                  residencePDFFileName = 'N';
                }
                break;
              case 'P':
                if (number >= 7 && number <= 12) {
                  residenceSVGFileName = 'P_7-12';
                  residencePDFFileName = 'P_7-12';
                } else if (number === 4 || number === 6) {
                  residenceSVGFileName = 'P_4&6';
                  residencePDFFileName = 'P_4&6';
                } else if (number === 5) {
                  residenceSVGFileName = 'P_5';
                  residencePDFFileName = 'P_5';
                } else {
                  residenceSVGFileName = 'P';
                  residencePDFFileName = 'P';
                }
                break;
              case 'PHNORTH':
                residenceSVGFileName = 'PHNORTH';
                residencePDFFileName = 'PHNORTH';
                break;
              case 'PHWEST':
                residenceSVGFileName = 'PHWEST';
                residencePDFFileName = 'PHWEST';
                break;
              case 'R':
                if (number >= 7 && number <= 12) {
                  residenceSVGFileName = 'R_7-12';
                  residencePDFFileName = 'R_7-12';
                } else if (number === 4) {
                  residenceSVGFileName = 'R_4';
                  residencePDFFileName = 'R_4';
                } else if (number === 6) {
                  residenceSVGFileName = 'R_6';
                  residencePDFFileName = 'R_6';
                }
                break;
              default:
                residenceSVGFileName = letter;
                residencePDFFileName = letter;
                break;
            }

            // Updates Key File Name
            switch (letter) {
              case 'A':
                if (number === 3 || number === 5 || number === 6) {
                  keySVGFileName = 'A_3-6';
                } else if (number === 4) {
                  keySVGFileName = 'A_4-12';
                } else if (number >= 7 && number <= 12) {
                  keySVGFileName = 'A_4-12';
                } else if (number === 15) {
                  keySVGFileName = 'A_15';
                } else if (number === 16) {
                  keySVGFileName = 'A_16';
                } else {
                  keySVGFileName = 'A';
                }
                break;
              case 'B':
                if (number >= 7 && number <= 10) {
                  keySVGFileName = 'B_7-10';
                } else if (number === 15) {
                  keySVGFileName = 'B_15';
                } else {
                  keySVGFileName = 'B';
                }
                break;
              case 'C':
                if (number >= 3 && number <= 6) {
                  keySVGFileName = 'C_3-6';
                } else if (number >= 7 && number <= 12) {
                  keySVGFileName = 'C_7-12';
                } else if (number === 15) {
                  keySVGFileName = 'C_15';
                } else {
                  keySVGFileName = 'C';
                }
                break;
              case 'D':
                if (number >= 3 && number <= 5) {
                  keySVGFileName = 'D_3-5';
                } else if (number >= 7 && number <= 8) {
                  keySVGFileName = 'D_7-8';
                } else if (number >= 9 && number <= 11) {
                  keySVGFileName = 'D_9-11';
                } else if (number === 6) {
                  keySVGFileName = 'D_6';
                } else {
                  keySVGFileName = 'D';
                }
                break;
              case 'E':
                if (number >= 4 && number <= 12) {
                  keySVGFileName = 'E_4-12';
                } else {
                  keySVGFileName = 'E';
                }
                break;
              case 'F':
                if (number >= 3 && number <= 12) {
                  keySVGFileName = 'F_3-12';
                } else {
                  keySVGFileName = 'F';
                }
                break;
              case 'G':
                if (number >= 4 && number <= 6) {
                  keySVGFileName = 'G_4-6';
                } else if (number >= 7 && number <= 12) {
                  keySVGFileName = 'G_7-12';
                } else {
                  keySVGFileName = 'G';
                }
                break;
              case 'H':
                if (number >= 4 && number <= 6) {
                  keySVGFileName = 'H_4-6';
                } else if (number >= 7 && number <= 12) {
                  keySVGFileName = 'H_7-12';
                } else {
                  keySVGFileName = 'H';
                }
                break;
              case 'I':
                if (number >= 4 && number <= 11) {
                  keySVGFileName = 'I_4-11';
                } else {
                  keySVGFileName = 'I';
                }
                break;
              case 'J':
                if (number >= 4 && number <= 11) {
                  keySVGFileName = 'J_4-11';
                } else if (number === 3) {
                  keySVGFileName = 'J_3';
                }
                break;
              case 'K':
                if (number >= 3 && number <= 11) {
                  keySVGFileName = 'K_3-11';
                } else {
                  keySVGFileName = 'K';
                }
                break;
              case 'L':
                if (number >= 4 && number <= 6) {
                  keySVGFileName = 'L_4-6';
                } else if (number > 7 && number <= 12) {
                  keySVGFileName = 'L_7-12';
                } else {
                  keySVGFileName = 'L';
                }
                break;
              case 'M':
                if (number >= 5 && number <= 12) {
                  keySVGFileName = 'M_5-12';
                } else {
                  keySVGFileName = 'M';
                }
                break;
              case 'N':
                if (number === 6) {
                  keySVGFileName = 'N_6';
                } else if (number === 4) {
                  keySVGFileName = 'N_4';
                } else if (number >= 7 && number <= 12) {
                  keySVGFileName = 'N_7-12';
                } else {
                  keySVGFileName = 'N';
                }
                break;
              case 'P':
                if (number >= 7 && number <= 12) {
                  keySVGFileName = 'P_7-12';
                } else if (number === 4 || number === 6) {
                  keySVGFileName = 'P_4&6';
                } else if (number === 5) {
                  keySVGFileName = 'P_5';
                } else {
                  keySVGFileName = 'P';
                }
                break;
              case 'R':
                if (number >= 7 && number <= 12) {
                  keySVGFileName = 'R_7-12';
                } else if (number === 4) {
                  keySVGFileName = 'R_4';
                } else if (number === 6) {
                  keySVGFileName = 'R_6';
                } else {
                  keySVGFileName = 'R';
                }
                break;
              default:
                keySVGFileName = letter;
                break;
            }

            var res = '';
            if (json[i]['unit_num'].indexOf('(') > -1) {
              if (json[i]['unit_num'].indexOf('PH') > -1) {
                res = json[i]['unit_num']
                  .split(' (')[0]
                  .split(' (')[0]
                  .split('PH')[1];
              } else {
                res = json[i]['unit_num'].split(' (')[0];
              }
            } else {
              res = json[i]['unit_num'];
            }

            parsed[i] = {
              id: json[i]['idx'], // Unique ID
              residence: res, // Residence name
              number: // Floor number
                json[i]['unit_num'].indexOf('PH') > -1
                  ? 0
                  : parseInt(
                      json[i]['unit_num']
                        .split(' (')[0]
                        .match(/(\d+|[^\d]+)/g)[0],
                      10
                    ),
              letter:
                json[i]['unit_num'].indexOf('PH') > -1
                  ? json[i]['unit_num'].split(' (')[0]
                  : json[i]['unit_num']
                      .split(' (')[0]
                      .match(/(\d+|[^\d]+)/g)[1],
              residenceSVGFileName: residenceSVGFileName,
              residencePDFFileName: residencePDFFileName,
              keySVGFileName: keySVGFileName,
              bedrooms: parseInt(
                json[i]['unit_type'].split('/')[0].split('BR')[0],
                10
              ),
              baths: parseFloat(
                json[i]['unit_type'].split('/')[1].split('BA')[0]
              ),
              price: Math.round(json[i]['price']),
              interior: json[i]['sqft'],
              exterior: json[i]['outdoor_sqft'],
              monthlycc: json[i]['common_charges'],
              monthlytaxes: json[i]['taxes']
            };
          }
        }

        // Sort residences by bedrooms and price
        let bedSorted = parsed.sort(function(a, b) {
          return a['bedrooms'] - b['bedrooms'];
        });
        let priceSorted = bedSorted.sort(function(a, b) {
          return a['price'] - b['price'];
        });
        this.setState({
          residences: tempRes > 0 ? tempRes : priceSorted,
          allResidences: priceSorted
        });
      });
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Cache residences if coming from child component
    if (fromChild) {
      tempRes = nextState.residences;
    } else {
      tempRes = [];
    }
    return true;
  }

  showCertainResidences(residences) {
    // Filter residences based on the provided criteria
    setTimeout(() => {
      var newFilteredArray = [];
      var filterRes;
      if (residences === 'penthouses') {
        filterRes = el => {
          if (
            el['number'] > 13 ||
            el.residence.indexOf('EAST') > -1 ||
            el.residence.indexOf('NORTH') > -1
          ) {
            return true;
          } else {
            return false;
          }
        };

        newFilteredArray = newFilteredArray.concat(
          this.state.residences.filter(filterRes)
        );
      } else if (residences === 'one-bedroom') {
        filterRes = el => {
          if (el['bedrooms'] === 1) {
            return true;
          } else {
            return false;
          }
        };

        newFilteredArray = newFilteredArray.concat(
          this.state.residences.filter(filterRes)
        );
      } else {
        var resArray = residences.split('&');
        filterRes = el => {
          if (el['residence'] === resArray[res]) {
            return true;
          } else {
            return false;
          }
        };
        for (var res in resArray) {
          if (resArray[res]) {
            newFilteredArray = newFilteredArray.concat(
              this.state.residences.filter(filterRes)
            );
          }
        }
      }

      this.setState({
        residences: newFilteredArray
      });
    }, 1500);
  }

  naturalSorter(as, bs) {
    // Sort strings naturally (e.g., "10" comes after "2")
    var a,
      b,
      a1,
      b1,
      i = 0,
      n,
      L,
      rx = /(\.\d+)|(\d+(\.\d+)?)|([^\d.]+)|(\.\D+)|(\.$)/g;
    if (as === bs) return 0;
    a = as.toLowerCase().match(rx);
    b = bs.toLowerCase().match(rx);
    L = a.length;
    while (i < L) {
      if (!b[i]) return 1;
      a1 = a[i];
      b1 = b[i++];
      if (a1 !== b1) {
        n = a1 - b1;
        if (!isNaN(n)) return n;
        return a1 > b1 ? 1 : -1;
      }
    }
    return b[i] ? -1 : 0;
  }

  onFilterColumn(filter, arrow) {
    // Sort residences based on the selected column and direction
    var newSort;
    var that = this;
    if (arrow === 'up') {
      newSort = this.state.residences.sort(function(a, b) {
        if (filter === 'residence') {
          return that.naturalSorter(a[filter], b[filter]);
        } else {
          return parseInt(b[filter], 10) - parseInt(a[filter], 10);
        }
      });
    } else {
      newSort = this.state.residences.sort(function(a, b) {
        if (filter === 'residence') {
          return that.naturalSorter(b[filter], a[filter]);
        } else {
          return parseInt(a[filter], 10) - parseInt(b[filter], 10);
        }
      });
    }

    this.setState({
      residences: newSort
    });
  }

  onFilterClick(e) {
    // Toggle filter overlay visibility
    e.currentTarget.classList.toggle('blue');

    if (this.state.filterOverlay) {
      this.setState({
        filterOverlay: false
      });
    } else {
      this.setState({
        filterOverlay: true
      });
    }
  }

  onViewClick(open) {
    // Closing the filter overlay when clicking on view button as well
    this.btnElement.classList.toggle('blue');
    this.setState({
      filterOverlay: open
    });

    this.scrollArrow.hideShowDownArrow();

    // Removing the children residences from the URL if they are there
    // 3 is normal for /availability/, however /availability/13-A&14-A/ etc... has 4
    if (window.location.pathname.split('/').length > 3) {
      window.history.pushState('', '', '/availability/');
      fromChild = true;
    } else {
      fromChild = false;
    }
  }

  onFilterItem(filter, checked) {
    // Add or remove filters based on checkbox state
    if (checked) {
      this.setState({
        filtersArray: this.state.filtersArray.concat(filter)
      });
    } else {
      this.setState({
        filtersArray: this.state.filtersArray.filter(function(i) {
          return i !== filter;
        })
      });
    }
  }

  sendResidences(resArray) {
    // Update residences state with filtered data
    this.setState({
      residences: resArray
    });
  }

  onViewFloorplanClick(fresidence, fstate, fexists) {
    // Update floorplan state and data
    this.setState({
      activeResidence: fresidence,
      floorplanState: fstate,
      planExists: fexists
    });

    for (var r = 0; r < this.state.residences.length; r++) {
      if (this.state.residences[r].id === fresidence) {
        this.setState({
          floorplanResidenceArray: this.state.residences[r]
        });
      }
    }
  }

  onCloseBtnClick(fstate) {
    // Close floorplan view
    this.setState({
      floorplanState: fstate
    });
  }

  sendCheckboxes(checkArray) {
    // Update checkbox state and share button state
    this.setState({
      checkboxArray: checkArray
    });
    if (checkArray.length > 0) {
      this.setState({
        disabledShare: false
      });
    } else {
      this.setState({
        disabledShare: true
      });
    }
  }

  onShareClick() {
    // Navigate to share page with selected residences
    this.props.history.push({
      pathname: '/share/',
      state: { checkboxArray: this.state.checkboxArray }
    });
  }

  delimitNumbers(str) {
    // Format numbers with commas
    return (str + '').replace(/\b(\d+)((\.\d+)*)\b/g, function(a, b, c) {
      return (
        (b.charAt(0) > 0 && !(c || '.').lastIndexOf('.')
          ? b.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
          : b) + c
      );
    });
  }

  sqmFormat(num) {
    // Convert square feet to square meters
    return this.delimitNumbers(parseInt(num * 0.09290304, 10));
  }

  render() {
    return (
      <div className="availability-page">
        {/* Filter and Share buttons */}
        <div className="filter-button-wrapper">
          <Button
            btnEl={el => (this.btnElement = el)}
            name="Filter"
            onClick={this.onFilterClick}
            idClass="filter-button"
          />
          <Button
            name="Share"
            disabled={this.state.disabledShare}
            onClick={this.onShareClick}
          />
        </div>
        {/* List and Filter components */}
        <div className="list-wrapper">
          <Filter
            onViewClick={this.onViewClick.bind(this)}
            filterOverlay={this.state.filterOverlay}
            residences={this.state.residences}
            allResidences={this.state.allResidences}
            sendResidences={this.sendResidences.bind(this)}
            filtersArray={this.state.filtersArray}
            onFilterItem={this.onFilterItem.bind(this)}
            onFilterColumn={this.onFilterColumn.bind(this)}
          />
          <List
            listElement={el => (this.listElementRef = el)}
            residences={this.state.residences}
            onViewFloorplanClick={this.onViewFloorplanClick.bind(this)}
            sendCheckboxes={this.sendCheckboxes.bind(this)}
          />
        </div>
        {/* Scroll arrow and floorplan components */}
        <ScrollArrow
          ref={i => {
            this.scrollArrow = i;
          }}
          listElementRef={this.listElementRef}
        />
        <VelocityComponent
          ref={e => {
            this.floorplanwrapper = e;
          }}
          duration={500}
          easing={this.state.floorplanState ? 'ease-out' : 'ease-in'}
          animation={this.state.floorplanState ? 'fadeIn' : 'fadeOut'}
        >
          <Floorplan
            {...this.state.floorplanResidenceArray}
            intft={this.delimitNumbers(
              this.state.floorplanResidenceArray.interior
            )}
            intsqm={this.sqmFormat(this.state.floorplanResidenceArray.interior)}
            hasext={
              this.state.floorplanResidenceArray.exterior > 1 ? true : false
            }
            extft={this.delimitNumbers(
              this.state.floorplanResidenceArray.exterior
            )}
            extsqm={this.sqmFormat(this.state.floorplanResidenceArray.exterior)}
            fstate={true}
            onCloseBtnClick={this.onCloseBtnClick.bind(this)}
            planExists={this.state.planExists}
          />
        </VelocityComponent>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Availability.js